module.exports = __webpack_public_path__ + "static/media/Obory.f1696207.md";